module.exports = __webpack_public_path__ + "static/media/post.873742b8.png";